<template>
  <div>
    <vg-heading>基本信息</vg-heading>
    <vg-card>
      <vg-view-field-list class="space-between">
        <vg-view-field label="申请编码"
                       :value="value.applicationSituation?.applicationCode"/>
        <template v-for="field in value.commonForm?.fields">
          <dp-application-view-field :key="field.applicationAttributeFieldId"
                                     :value="field"/>
        </template>
        <vg-view-field label="申请状态"
                       :value="value.applicationSituation?.passCardStatus | enumText(passCardStatus)"/>
      </vg-view-field-list>
    </vg-card>
  </div>
</template>

<script>
import VgHeading from "@/components/Html/VgHeading.vue";
import VgViewFieldList from "@/components/Commons/VgViewFieldList.vue";
import DpApplicationViewField
  from "@/views/DigitalPassApplications/DigitalPassApplication/DpApplicationViewField/index.vue";
import VgCard from "@/components/Commons/VgCard.vue";
import VgViewField from "@/components/Commons/VgViewField.vue";
import passCardStatus from "@/domain/pass-card-status";

export default {
  name: "BasicInfo",
  data() {
    return {
      passCardStatus
    }
  },
  components: {VgViewField, VgCard, DpApplicationViewField, VgViewFieldList, VgHeading},
  props: {
    value: null
  }
}
</script>

<style scoped>
</style>
